import { jwtDecode } from "jwt-decode";
import api from "@/utils/api";

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem("token") || "",
    user: (() => {
      try {
        return JSON.parse(localStorage.getItem("user"));
      } catch (e) {
        return null;
      }
    })(),
    permissions: (() => {
      try {
        return JSON.parse(localStorage.getItem("permissions")) || [];
      } catch (e) {
        return [];
      }
    })(),
    roles: (() => {
      try {
        return JSON.parse(localStorage.getItem("roles")) || [];
      } catch (e) {
        return [];
      }
    })(),
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    token: (state) => state.token,
    user: (state) => state.user,
    permissions: (state) => state.permissions,
    roles: (state) => state.roles,
    hasPermission: (state) => (permission) => {
      if (!permission) return true;
      const normalize = (p) => p.toUpperCase().replace(/[:-]/g, "_");
      const normalizedReq = normalize(permission);
      return state.permissions.some((up) => normalize(up) === normalizedReq);
    },
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
      try {
        const decoded = jwtDecode(token);
        state.user = decoded;
        state.permissions = decoded.permissions || [];
        localStorage.setItem("user", JSON.stringify(decoded));
        localStorage.setItem(
          "permissions",
          JSON.stringify(decoded.permissions || []),
        );
      } catch (e) {
        state.user = null;
        state.permissions = [];
      }
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
      localStorage.setItem("permissions", JSON.stringify(permissions));
    },
    setRoles(state, roles) {
      state.roles = roles;
      localStorage.setItem("roles", JSON.stringify(roles));
    },
    clearAuth(state) {
      state.token = "";
      state.user = null;
      state.permissions = [];
      state.roles = [];
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("permissions");
      localStorage.removeItem("roles");
      localStorage.removeItem("appModules");
    },
  },
  actions: {
    async login({ commit }, credentials) {
      const response = await api.post("/auth/login", credentials);
      const { token, user } = response.data.data;
      commit("setToken", token);
      commit("setPermissions", user.permissions);
      commit("setRoles", user.roles);
      return response.data;
    },
    logout({ commit }) {
      commit("clearAuth");
      window.location.href = "/login";
    },
    initializeAuth({ commit, state }) {
      if (state.token) {
        commit("setToken", state.token);
      }
    },
    reSyncPermissions({ commit }) {
      try {
        const permissions =
          JSON.parse(localStorage.getItem("permissions")) || [];
        commit("setPermissions", permissions);
      } catch (e) {
        commit("setPermissions", []);
      }
    },
    reSyncRoles({ commit }) {
      try {
        const roles = JSON.parse(localStorage.getItem("roles")) || [];
        commit("setRoles", roles);
      } catch (e) {
        commit("setRoles", []);
      }
    },
  },
};
